import "./Signup.css";

import { GetPasswordStrength, PasswordStrengthBar } from "../components/PasswordStrengthBar";
import { useRef, useState } from "react";

import { PAGES } from "../constants";
import axios from "axios";
import logo from "../abe_logo.png";
import { useNavigate } from "react-router-dom";

function Signup() {
  const navigate = useNavigate();

  const minPasswordLength = 8;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [termsOfUseChecked, setTermsOfUseChecked] = useState(false);

  const [signupError, setSignupError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const termsOfUseRef = useRef(null);

  const handleSignup = async (event) => {
    event.preventDefault();

    setSignupError("");
    setEmailError("");
    setPasswordError("");

    // Check if terms of use is checked
    if (!termsOfUseChecked) {
      setSignupError("Please agree to the terms of use");
      return;
    }

    // Check if password is valid
    const passwordStrength = GetPasswordStrength(password, minPasswordLength);
    if (passwordStrength.score === 0 && passwordStrength.message !== "") {
      // setSignupError("Please create a more secure password");
      return;
    }

    // Call API
    const signupUrl = `${process.env.REACT_APP_BASE_URL}/user/signup`;
    const signupData = {
      email: email,
      password: password,
    };
    const signupConfig = {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    };
    axios.post(signupUrl, signupData, signupConfig)
      .then(response => {
        navigate(PAGES.AUTH_VERIFICATION, { state: { email: email } });
      })
      .catch(error => {
        if (error.response) {
          // If detail is a string, display it. else if it is an array, display the first error message
          if (typeof error.response.data.detail === "string") {
            setSignupError(error.response.data.detail);
          } else if (Array.isArray(error.response.data.detail)) {
            error.response.data.detail.forEach(detail => {
              if (detail.loc[1] === "username") {
                setEmailError(detail.msg);
              } else if (detail.loc[1] === "password") {
                setPasswordError(detail.msg);
              }
            });
          }
        } else {
          setSignupError("Unable to connect to server");
        }
      });
  }

  const handleBackButton = () => {
    navigate(PAGES.AUTH);
  }

  const setInputs = (event) => {
    setEmail(emailRef.current.value);
    setPassword(passwordRef.current.value);
    setTermsOfUseChecked(termsOfUseRef.current.checked);

    // Update error messages to be empty if the relevant input field is updated
    if (emailRef.current.value !== "") setEmailError("");
    if (passwordRef.current.value !== "") setPasswordError("");
  }

  return (
    <div className="login-container" data-testid="signup-page-div">
      <img src={logo} className="logo" alt="logo" />

      <form onSubmit={handleSignup}>
        <input className="auth-input" type="email" placeholder="Email" ref={emailRef} onChange={setInputs} />
        <p className="auth-input-error-text">{emailError}</p>

        <input className="auth-input" type="password" placeholder="Password" ref={passwordRef} onChange={setInputs} />
        <p className="auth-input-error-text">{passwordError}</p>
        <PasswordStrengthBar
          className="signup-password-strength-bar"
          password={password}
          minLength={minPasswordLength}
        />

        <input className="terms-of-use-checkbox" type="checkbox" id="terms-of-use" ref={termsOfUseRef} onChange={setInputs} />
        <label className="terms-of-use-label" for="terms-of-use">I have read and agree to the <a href={PAGES.AUTH_TERMS_OF_USE} target="_blank" rel="noopener noreferrer">terms of use</a>.</label>

        <div className="auth-center-contents">
          {signupError !== "" && <p className="error-message">{signupError}</p>}
          <input type="submit" className="auth-button" value="Sign up" />
        </div>
      </form>

      <button className="authentication-form-hyperlink" onClick={handleBackButton}>Go back to login</button>
    </div>
  );
}

export default Signup;
